import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormLink from '../../../../library/form/components/FormLink';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle';
import FormStatus from '../../../../library/form/components/FormStatus';
import DocFormReview from "../../../cmn/docReviewStatus/DocFormReview";
import FormWrapper from '../../../../library/form/components/FormWrapper'

import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';
import BudgetHeaderLocationWiseViewRow from './BudgetHeaderLocationWiseViewRow';

const BudgetHeaderLocationWiseViewer = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null);

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='' />
                        </span>
                    </UiTitle>

                    <UiAction>
                        <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                        <FormButton formObject={formObject} ksc="h" rowKey=""
                            action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <UiGridColTwo>
                        <UiCol>
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "itemId" }} value="Item Id" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "itemId" }} className='' />
                                </li>
                                <li>
                                    <FormAttachment imgHeight="50px" formObject={formObject} headerKey="sharedFields" action={{ InputType: "i", paramName: "itemImage" }} />
                                    <FormLink formObject={formObject} headerKey="sharedFields" linkProp={{ target: "_blank" }}
                                        action={{ paramName: "itemName", actionId: "show", actionName: "itemComp" }}
                                    />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat1" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat1" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat2" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat2" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "budgetDate" }} value="Budget Date" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "budgetDate" }} className='' />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} headerKey="sharedFields" action={{ paramName: "currency" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "currency" }} value="Currency" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "currency" }} className='' />
                                </FormWrapper>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "status" }} value="Status" />
                                    </span>
                                    <FormStatus formObject={formObject} headerKey="docStatus"/>
                                </li>
                            </ul>
                        </UiCol>
                        <UiCol>
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat3" }} value="Plan Group" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat3" }} className='' />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} headerKey="sharedFields" action={{ paramName: "bomName" }}>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "bomName" }} value="BOM" />
                                    </span>
                                    <FormLink className="uiLink" formObject={formObject} headerKey="sharedFields" linkProp={{ target: "_blank" }}
                                        action={{ paramName: "bomName", actionId: "show", actionName: "bomComp" }} />
                                </FormWrapper>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat4" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat4" }} className='' />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat5" }} value="" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat5" }} className='' />
                                </li>

                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "profile" }} value="Profile" />
                                    </span>
                                    <FormLink formObject={formObject} headerKey="sharedFields" linkProp={{ target: "_blank" }}
                                        action={{ paramName: "profile", actionId: "show", actionName: "proComp" }}
                                    />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "review" }} value="Review" />
                                    </span>
                                    <DocFormReview formObject={formObject} />
                                </li>
                            </ul>
                        </UiCol>
                    </UiGridColTwo>
                    <div style={{ overflowX: 'auto' }}>
                        <ul className="uiListTable uiProductionTable" style={{ minWidth: '695px' }}>
                            <li className="uiSearchHeading">
                                <ul>
                                    <li className="uiColumnLeft uiColumn100"><SarasTrans value="Sheet ID" /></li>
                                    <li className="uiColumnLeft" style={{ width: '185px' }}><SarasTrans value="Location" /></li>
                                    <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                    <li className="uiColumnRight uiColumnQty"><SarasTrans value="Quantity" /></li>
                                    <li className="uiColumnRight uiColumnQty"><SarasTrans value="Linked Qty" /></li>
                                    <li className="uiColumnLeft" style={{ width: '220px' }}><SarasTrans value="Comment" /></li>
                                </ul>
                            </li>
                            {Object.values(viewData).map(row => (
                                <li key={row.rowKey}>
                                    <BudgetHeaderLocationWiseViewRow formObject={formObject}
                                        rowKey={row.rowKey} viewData={row} />
                                </li>
                            ))}
                            <li>
                                <ul className="uiDPEditLine">
                                    <li className="uiColumnLeft uiColumn100" />
                                    <li className="uiColumnLeft" style={{ width: '185px' }}><SarasTrans value="Total Quantity" /></li>
                                    <li className="uiColumnLeft uiColumn50">
                                    </li>
                                    <li className="uiColumnRight uiColumnQty">
                                        <div>
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalQty1' }} className="uiHighlightKey" />
                                        </div>
                                        <FormWrapper formObject={formObject} headerKey="sharedFields"
                                            action={{ paramName: 'totalQty2' }} customWrapper="div">
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalQty2' }} className="uiHighlightKey" />
                                        </FormWrapper>
                                    </li>
                                    <li className="uiColumnRight uiColumnQty">
                                        <div>
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalLinkedQty1' }} className="uiHighlightKey" />
                                        </div>
                                        <FormWrapper formObject={formObject} headerKey="sharedFields"
                                            action={{ paramName: 'totalLinkedQty2' }} customWrapper="div">
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalLinkedQty2' }} className="uiHighlightKey" />
                                        </FormWrapper>
                                    </li>
                                    <li className="uiColumnLeft" style={{ width: '220px' }} />
                                </ul>
                            </li>
                        </ul>
                    </div>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(BudgetHeaderLocationWiseViewer, "budgetHeader", "budgetHeader");
